import { ActiveChart } from './constants';

const initialState = {
  activeChart: null,
  testChartData: null,
};

export const activeChartReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case ActiveChart.activeChartSuccess:
      return {
        ...state,
        activeChart: action.data
      };
    case ActiveChart.fetchTestChartDataSuccess:
      return {
        ...state,
        testChartData: action.data
      };
    default:
      return state;
  }
};
